exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-management-wrapper .menu-editor .el-dialog {\n  margin-top: 1vw !important;\n}\n.menu-management-wrapper .ext-param-pannel {\n  margin-top: 30px;\n  padding-top: 10px;\n  border-top: 1px dashed #979797;\n}\n.menu-management-wrapper .ext-param-pannel .operator-row {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.menu-management-wrapper .ext-param-pannel .operator-row .warning {\n  margin-left: 10px;\n}", ""]);

// exports
